<template>
  <div class="col-xl-7 col-lg-8">
    <div class="card card-body shadow text-left">
      <h1 class="h5 text-center">Potrdite email naslov</h1>
      <p>Vnesite kodo, ki smo jo poslali na vaš email naslov</p>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit(verifyEmail)" novalidate>

          <ValidationProvider name="name" vid="_id" v-slot="{ errors }">
            <div v-if="errors[0]" class="alert alert-danger" role="alert">
              {{ errors[0] }}
            </div>
          </ValidationProvider>

          <div class="form-group">
            <ValidationProvider name="code" vid="code" rules="required" v-slot="{ errors }">
              <input type="text" class="form-control" v-model="emailVerification.code" name="email" placeholder="Potrditvena koda" :class="{ 'is-invalid': errors[0] }">
              <span class="text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <button class="btn btn-primary btn-block" type="submit">Potrdi</button>
        </form>
      </ValidationObserver>
    </div>
    <div class="text-center text-small mt-3">
      Že imate račun?
      <router-link to="/login" class="accent bold">Prijavite se tukaj</router-link>.
    </div>
  </div>
</template>

<script>

export default {
  name: 'EmailVerification',
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  data: () => ({
    emailVerification: {
      code: '',
      _id: '',
      type: ''
    },
  }),
  methods: {
    verifyEmail: function(){
      this.emailVerification._id = this.$route.params.verificationId;
      this.emailVerification.type = this.$route.name;
      fetch( process.env.VUE_APP_API + '/emails/tokens', {
        method : 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify(this.emailVerification)
      })
      .then(response => response.json())
      .then(response => {
        if(response.error){
          this.$refs.form.setErrors(response.error.messages);
        }else{
          if(this.$route.name == 'registerVerification'){
            return this.$router.replace('/register/tokens/' + response._id);
          }else{
            return this.$router.replace('/password/reset/' + response._id);
          }
        }
      });
    }
  }
}
</script>
